export default "__VITE_ASSET__68e020b3__"